/**
 * Admin API client.
 * PIN is stored in sessionStorage; sent as X-Admin-Pin on every request.
 */
const API_URL = process.env.REACT_APP_BACKEND_URL;
const PIN_KEY = 'pekika_admin_pin';

export const getPin = () => sessionStorage.getItem(PIN_KEY) || '';
export const setPin = (pin) => sessionStorage.setItem(PIN_KEY, pin);
export const clearPin = () => sessionStorage.removeItem(PIN_KEY);
export const isLoggedIn = () => !!getPin();

const headers = () => ({
  'Content-Type': 'application/json',
  'X-Admin-Pin': getPin(),
});

const handle = async (res) => {
  if (res.status === 401) {
    clearPin();
    throw new Error('Niet ingelogd');
  }
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || `HTTP ${res.status}`);
  }
  return res.json();
};

export const adminLogin = async (pin) => {
  const res = await fetch(`${API_URL}/api/admin/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ pin }),
  });
  if (!res.ok) throw new Error('Onjuiste PIN');
  setPin(pin);
  return true;
};

export const listProducts = async () => {
  const res = await fetch(`${API_URL}/api/admin/products`, { headers: headers() });
  return handle(res);
};

export const createProduct = async (payload) => {
  const res = await fetch(`${API_URL}/api/admin/products`, {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify(payload),
  });
  return handle(res);
};

export const updateProduct = async (id, payload) => {
  const res = await fetch(`${API_URL}/api/admin/products/${id}`, {
    method: 'PATCH',
    headers: headers(),
    body: JSON.stringify(payload),
  });
  return handle(res);
};

export const deleteProduct = async (id) => {
  const res = await fetch(`${API_URL}/api/admin/products/${id}`, {
    method: 'DELETE',
    headers: headers(),
  });
  return handle(res);
};
